// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__+uF-K","loading_spinne":"styles_loading_spinne__8p5x9","spin":"styles_spin__qnZk1"};